const baseURL = 'https://hotel.kuytawa.com';

export default baseURL;
